import ImgKhitbah from '@assets/images/khitbah.jpg';
import ImgTransStudio from '@assets/images/trans-studio.jpg';
import ImgPerkenalanKeluarga from '@assets/images/perkenalan-keluarga.jpg';
import ImgFebriAldi from '@assets/images/febri-aldi.png';

export const stories = [
  {
    title: 'Perkenalan ',
    date: '21 Juli 2020',
    description:
      'Kami bisa berkenalan melalui wasilah teman kerja saya, lebih tepatnya salah satu atasan saya di tempat kerja yang kebetulan juga merupakan om nya Yayuk. Kami berkenalan secara online tanpa pernah bertemu secara langsung sampai kurang lebih dua tahun ke depan. Kami pun saling follow di sosial media tapi hampir tidak ada komunikasi, hanya beberapa kali saling komen story. Pada waktu itu tidak banyak yang saya tau tentang Yayuk, saya hanya diberi tau oleh om nya bahwa Yayuk ini baru daftar kuliah setelah sebelumnya berhenti 2 tahun sejak lulus SMA karna mengikuti pendidikkan tahfidz di salah satu pondok tahfidz di Bandung.',
    image: '',
  },
  {
    title: 'Kembali Berkomunikasi',
    date: '31 Desember 2021',
    description:
      'Di penghujung tahun 2021 Yayuk mengunggah beberapa story mengenai resolusi 2022, saya pun iseng mengomentari dan Yayuk membalasnya. Dari percakapan tersebut kemudian saya memberanikan diri untuk ngajak ketemu agar bisa berkenalan secara langsung dan Yayuk pun setuju. Selanjutnya kami tinggal menentukan tempat dan waktu berhubung kami sama-sama punya kesibukan.',
    image: '',
  },
  {
    title: 'Jumpa Pertama',
    date: '8 Januari 2022',
    description:
      'Di Minggu pertama tahun 2022 saya kembali menghubungi Yayuk untuk ngajak ketemu di hari Sabtu atau Minggu, saat itu kebetulan hari Sabtu Yayuk akan menghadiri acara wisuda tahfidz temannya di masjid Trans Studio Bandung. Kami pun sepakat untuk bertemu di sana setelah selesai acara. Singkat cerita akhirnya kami pun bertemu, dan di sana kami bercerita cukup banyak mengenai aktifitas masing-masing, keluarga, rencana-rencana di masa depan, dll.',
    image: ImgTransStudio,
  },
  {
    title: 'Perkenalan Keluarga',
    date: '15, 22, 30 Januari 2022',
    description:
      'Beberapa hari setelah berjumpa saya diminta oleh orang tua Yayuk untuk datang ke rumah dan saya pun menyanggupi. Saya datang ke rumah Yayuk tepat seminggu setelah kami berjumpa. Di sana saya bertemu dengan orang tua nya dan juga kakak beserta kakak ipar nya, karna Yayuk merupakan anak bungsu. Perkenalan dengan keluarga ini berlanjut ke minggu berikutnya, dan di minggu depannya lagi tanggal 30 Januari 2022 giliran Yayuk yang bertemu keluarga saya.',
    image: ImgPerkenalanKeluarga,
  },
  {
    title: 'Khitbah',
    date: '19 Februari 2022',
    description:
      'Setelah perkenalan singkat dan beberapa kali bertemu dengan orang tua kemudian kami memutuskan untuk melanjutkan ke proses berikutnya, yaitu khitbah.',
    image: ImgKhitbah,
  },
  {
    title: 'Pertemuan Orang Tua',
    date: '25 Juni 2022',
    description:
      'Akhirnya tiba di masa di mana saya dan orang tua kembali berkunjung ke rumah Yayuk untuk menentukan tanggal pernikahan yang disepakati akan diselenggarakan pada hari Rabu tanggal 04 Desember 2025.',
    image: ImgFebriAldi,
  },
];
